import PropTypes from 'prop-types';

import ToastMessage from '@/utils/toastMessage/ToastMessage';
import { Button, Form, Input } from 'antd';
import { useDispatch } from 'react-redux';
import { AntButton } from '@/common/ant-components/AntButton';
import { LockOutlined, UserOutlined } from '@ant-design/icons';

const UserLogin = ({
  validateMobileNumber,
  firstInputRef,
  loading,
  handleLogin,
  successLoading,
}) => {
  const dispatch = useDispatch();
  return (
    <>
      <ToastMessage />

      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={(value) => handleLogin('login/', value, dispatch)}
        className="modern-login-form"
        layout="vertical"
      >
        <Form.Item
          name="mobileNumber"
          label={<span className="form-label">Username</span>}
          className="form-label"
          rules={[
            {
              required: true,
              // validator: (_, value) => validateMobileNumber(value),
            },
          ]}
        >
          <Input
            // maxLength={10}
            ref={firstInputRef}
            placeholder="Enter your username"
            prefix={<UserOutlined className="input-icon" />}
            size="large"
            className="modern-input"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label={<span className="form-label">Password</span>}
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password
            placeholder="Enter your password"
            style={{ width: '100%' }}
            prefix={<LockOutlined className="input-icon" />}
            size="large"
            className="modern-input"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, marginTop: '12px' }}>
          <AntButton
            className="modern-submit-button"
            htmlType="submit"
            loading={loading || successLoading}
            block
            size="large"
          >
            {loading || successLoading ? 'Signing in...' : 'Sign In'}
          </AntButton>
        </Form.Item>
      </Form>
    </>
  );
};

UserLogin.propTypes = {
  navigate: PropTypes.func,
  firstInputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  validateMobileNumber: PropTypes.func,
  loading: PropTypes.bool,
  handleLogin: PropTypes.func,
};

export default UserLogin;
